import { Component, OnInit } from '@angular/core';
import {AuthService} from "../../../../services/auth/auth.service";

@Component({
    selector: 'app-admin-side-nav',
    templateUrl: './admin-side-nav.component.html',
    styleUrls: ['../side-nav.shared.scss', './admin-side-nav.component.css'],
    standalone: false
})
export class AdminSideNavComponent implements OnInit {

  constructor(private auth:AuthService) { }

  ngOnInit(): void {
  }

  hasAccess(permissions: string[]) {
    return this.auth.hasAnyPermission(permissions);
}

  stopDropdownClose(event: Event) {
    event.stopPropagation();
  }

}
